import React, { FC } from 'react';
import { useController } from 'react-hook-form';
import { FormHelperText } from 'atoms/FormHelperText';
import { Select as CommonSelect } from 'atoms/Select';
import { IFormSelect } from 'organisms/Form/Select/types';

export const Select: FC<IFormSelect> = ({
  control,
  name,
  className,
  ...fieldProps
}) => {
  const { field, fieldState } = useController({
    control,
    name,
  });

  return (
    <div className={className}>
      <CommonSelect hasError={!!fieldState.error} {...fieldProps} {...field} />
      {!!fieldState.error && (
        <FormHelperText error>{fieldState.error.message}</FormHelperText>
      )}
    </div>
  );
};
